<div class="table-container">
  <div class="header-container">
    <div class="title-container tw-items-center">
      <h2 class="tw-font-bold mb-0">{{ title }}</h2>
      <div *ngIf="title !== 'Gross Receipts'" class="edit" color="primary" mat-raised-button>
        <div (click)="onEditClicked()" class="edit-text-container">
          <span>Edit</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!loading" class="content-container new-fd-view-table">
    <table class="data-table-values tw-w-full">

      <ng-container *ngIf="fieldsMap[title]">
        <tr *ngFor="let field of fields" class="tw-flex tw-w-full">
          <td class="tw-flex tw-justify-between tw-w-full tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
            <span class="tw-text-left">{{ field.label }}</span>
            <span class="tw-text-right">{{ field?.value?.source ? (field?.value | async) : field?.value || '-' }}</span>
        </tr>
      </ng-container>

      <!-- Grant & Credit Info -->
      <ng-container *ngIf="title === 'Grant & Credit Info'">
        <div *ngIf="getObjectKeys(grantsCreditsReceived).length">
          <div *ngFor="let receivedGrantCreditKey of getObjectKeys(grantsCreditsReceived)">
            <tr class="tw-flex tw-w-full" *ngFor="let grantCreditKey of getObjectKeys(grantsCreditsReceived[receivedGrantCreditKey])">
              <td class="tw-flex tw-justify-between tw-w-full tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                <span class="tw-text-left">{{ grantsCreditsReceived[receivedGrantCreditKey][grantCreditKey].shortName }}</span>
                <span class="tw-text-right">{{ grantsCreditsReceived[receivedGrantCreditKey][grantCreditKey].value }}</span>
              </td>
            </tr>
          </div>
        </div>
        <div *ngIf="!getObjectKeys(grantsCreditsReceived).length" class="tw-p-3">Received No Grant or Credit</div>
      </ng-container>
    </table>
  </div>
  <div *ngIf="loading" style="display: flex; justify-content: center; padding: 20px;">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
